module.exports = __webpack_public_path__ + "static/img/alpaga-03.0b97fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-03.png
// module id = 62
// module chunks = 0